import { render, staticRenderFns } from "./storeCoupon.vue?vue&type=template&id=18446b7a&scoped=true"
import script from "./storeCoupon.vue?vue&type=script&lang=js"
export * from "./storeCoupon.vue?vue&type=script&lang=js"
import style0 from "./storeCoupon.vue?vue&type=style&index=0&id=18446b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18446b7a",
  null
  
)

export default component.exports